import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LegalLinks } from "@/components/LegalLinks";
import { TERMS, PRIVACY, LEGAL_EFFECTIVE, LEGAL_CONTACT } from "@/constants/legal";

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

function Section({ title, intro, items, outro }) {
  return (
    <section id={slug(title)} data-testid={`legal-section-${slug(title)}`} className="scroll-mt-6">
      <h2 className="text-base font-semibold text-slate-900 md:text-lg">{title}</h2>
      <p className="mt-2 text-sm leading-relaxed text-slate-600 md:text-base">{intro}</p>
      {items && <ul className="mt-2 list-disc space-y-1 pl-5 text-sm leading-relaxed text-slate-600 md:text-base">{items.map((i) => <li key={i}>{i}</li>)}</ul>}
      {outro && <p className="mt-2 text-sm leading-relaxed text-slate-600 md:text-base">{outro}</p>}
    </section>
  );
}

export default function LegalPage({ kind }) {
  const doc = kind === "privacy" ? PRIVACY : TERMS;
  return (
    <div className="min-h-screen bg-slate-50" data-testid={`legal-page-${kind}`}>
      <header className="border-b bg-white" style={{ borderColor: "var(--po-border)" }}>
        <div className="mx-auto flex max-w-3xl items-center justify-between px-6 py-4">
          <Link to="/login" data-testid="legal-logo-link"><img src="/brand/logo.png" alt="PressOps" className="h-9 w-auto" /></Link>
          <Link to="/login" data-testid="legal-back-link" className="inline-flex items-center gap-1 text-sm font-medium text-[#2B7F77] hover:underline"><ArrowLeft className="h-4 w-4" />Back to sign in</Link>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-6 py-10">
        <article className="po-card space-y-8 p-6 sm:p-10 fade-up">
          <div className="border-b pb-6" style={{ borderColor: "var(--po-border)" }}>
            <h1 data-testid="legal-title" className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">{doc.title}</h1>
            <p className="mt-3 text-sm text-slate-500" data-testid="legal-effective">Effective date: {LEGAL_EFFECTIVE}</p>
            <p className="text-sm text-slate-500">Contact: <a href={`mailto:${LEGAL_CONTACT}`} data-testid="legal-contact-email" className="font-medium text-[#2B7F77] hover:underline">{LEGAL_CONTACT}</a></p>
          </div>
          {doc.sections.map(([title, intro, items, outro]) => <Section key={title} title={title} intro={intro} items={items} outro={outro} />)}
        </article>
        <footer className="mt-8 flex flex-col items-center gap-2 text-xs text-slate-400">
          <LegalLinks testId="legal-footer-links" />
          <p>© {new Date().getFullYear()} SpeedPrints Ghana Limited</p>
        </footer>
      </main>
    </div>
  );
}
